import { Box, Button, Card, CardContent, CardMedia, Container, IconButton, Rating, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getallbooksdata, addtoCart } from '../services/Apis';
import { useNavigate } from 'react-router-dom';
import { useFilter } from '../context/FilterContext';

const NewRelease = () => {
    const [newReleaseData, setNewReleaseData] = useState([]);
    const navigate = useNavigate()
   

    useEffect(() => {
        const fetchBooks = async () => {
            const books = await getallbooksdata();
            // Filter out books that are out of stock
            const availableBooks = (books.newReleases || []).filter(book => book.availability);
            setNewReleaseData(availableBooks);
        };
        fetchBooks();
    }, []);


        const { token, isLoggedIn } = useFilter()
    const handleAddToCart = async (bookId) => {

        if (isLoggedIn && token) {
            try {
                await addtoCart({ bookId, quantity: 1 });
                navigate('/cart');
            } catch (error) {
                alert("Failed to add to cart. Please login or try again.");
            }
        } else {
            navigate("/login")
        }
    };

    const handleBuyNow = async (book) => {
         if (isLoggedIn && token) {
        try {
            navigate('/checkout', { state: book });

        } catch (error) {
            console.log("Failed to add to cart. Please login or try again.");
        }} else {
            navigate("/login")
        }
    };

    return (
        <Container maxWidth="xl" width={"80%"} sx={{ pr: "0px !important", pl: "10px !important" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5} px={0}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 600,
                        fontFamily: "Poppins",
                        color: "#CB4422",
                        mt:2,
                        paddingLeft: 1,
                    }}
                >
                    New Releases
                </Typography>

                
            </Box>

            <Box
                sx={{
                    display: "flex",
                   flexWrap:'wrap',
                   gap:2,
                    justifyContent:{xs:'center' , md:"flex-start"},
                    
                    mb:2
                   
                }}
            >
                {newReleaseData.filter(book => book.isActive).map((book) => (
                    <Box key={book.id} sx={{ minWidth: { xs: '80%', sm: 280, md: 250, lg:250} , flexShrink: 0, cursor: "pointer" }}>
                        <Card sx={{ position: "relative", boxShadow: "none", border: "1px solid lightgrey" }}>
                            {/* Discount badge */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 8,
                                    left: 0,
                                    bgcolor: "black",
                                    color: "white",
                                    px: 1,
                                    py: 0.5,
                                    fontSize: "12px",
                                    zIndex: 2,
                                    borderRadius: 0.5,
                                }}
                            >
                                {book.discountOffer}% off
                            </Box>

                            {/* Shopping Cart icon */}
                            <IconButton
                                disableRipple
                                disableFocusRipple
                                sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    zIndex: 2,
                                    bgcolor: "#FFB300",
                                    color: "#000",
                                    "&:hover": {
                                        bgcolor: "#FFB300",
                                    },
                                }}
                                onClick={() => handleAddToCart(book.id)}
                            >
                                <i className="fa-solid fa-cart-shopping" style={{ fontSize: "14px", color: "black" }}></i>
                            </IconButton>

                            {/* Book Image */}
                            <CardMedia
                                onClick={() => navigate(`/book-overview/${book.id}`)}
                                
                                loading="lazy"
                                component="img"
                                height={200}
                                image={book?.bookImages[0]?.imageUrl}
                                alt={book.title}
                                sx={{ objectFit: "contain" }}
                            />

                            <CardContent sx={{ textAlign: "center" }}>
                                {/* Title */}
                                <Typography variant="body1" fontWeight="bold" noWrap sx={{ my: 0 }}>
                                    {book.title}
                                </Typography>

                                {/* Yearly & Author */}
                                <Typography fontSize={10} variant="caption" color="text.secondary">
                                    Yearly - {book.publishingYear}, by {book.authorName}
                                </Typography>

                                {/* Rating */}
                                <Box mt={1}>
                                    <Rating value={book.rating} precision={0.5} readOnly size="small" />
                                </Box>

                                {/* Price and Buy Now */}
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1 }}>
                                    <Typography variant="h6" color="#000">
                                        ₹{book.price ? book.price.toFixed(2) : 'N/A'}
                                    </Typography>

                                    <Button variant="contained" size="small" onClick={() => handleBuyNow(book)}

                                        sx={{
                                            textTransform: "none",
                                            fontSize: "10px",
                                            borderRadius: "2px",
                                            px: 2,
                                            boxShadow: "none",
                                            "&:hover": {
                                                backgroundColor: "primary.main",
                                                boxShadow: "none",
                                            },
                                        }}
                                    >
                                        Buy Now
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                ))}
            </Box>
        </Container>
    );
};

export default NewRelease;
